import { Http } from './http'
const http = Http.create('https://go.atta.com.vc/')
export class GoAttaService {
	static async shortUrlLink(url: string) {
		const { data } = await http.post('/generate', { url })
		return data.url
	}
}
export default GoAttaService
